export const namespace = 'core-prospect-map';
const ns = (name) => `${namespace}/${name}`;

export const SYNC_MAP_VIEWPORT = ns('SYNC_MAP_VIEWPORT');
export const TOGGLE_SATELLITE_VISIBILITY = ns('TOGGLE_SATELLITE_VISIBILITY');
export const RECENTER_MAP = ns('RECENTER_MAP');
export const SET_DRAWING_MODE = ns('SET_DRAWING_MODE');
export const SET_FULL_MAP_MODE = ns('SET_FULL_MAP_MODE');
